import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const fileFoldersService = {
  Get,
  GetFolderDeps,
  Add,
  Edit,
  ParentEdit,
  FolderDocChange,
  Del,
  OrgAdd,
  OrgEdit,
  OrgParentEdit,
  OrgFolderDocChange,
  OrgDel
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function Get(folderType, folderCode, allFolders) {
  return axios.get(model.baseUrl + 'FileFolders?folderType=' + `${folderType}` + `${(folderCode ? '&folderCode=' + folderCode : '')}` + `${'&AllFolders=' + allFolders}`).then(extract);
}

async function GetFolderDeps(folderCode) {
  return axios.get(model.baseUrl + 'FileFolders/FolderDepGet?folderCode=' + `${folderCode}`).then(extract);
}

async function Add(folderName, parentFolderCode) {
  return axios
    .put(model.baseUrl + 'FileFolders', {
      FolderName: folderName,
      ParentFolderCode: parentFolderCode
    })
    .then(extract);
}

async function Edit(FolderCode, FolderName) {
  return axios
    .patch(model.baseUrl + 'FileFolders', {
      FolderCode: FolderCode,
      FolderName: FolderName
    })
    .then(extract);
}

async function ParentEdit(FolderCode, ParentFolderCode) {
  return axios
    .patch(model.baseUrl + 'FileFolders/ParentEdit', {
      FolderCode: FolderCode,
      ParentFolderCode: ParentFolderCode
    })
    .then(extract);
}

async function FolderDocChange(DocumentVersionCodes, FolderCode) {
  return axios
    .patch(model.baseUrl + 'FileFolders/FoldersDocChange', {
      DocumentVersionCodes: DocumentVersionCodes,
      FolderCode: FolderCode
    })
    .then(extract);
}

async function Del(FolderCode, WithSubfolder) {
  return axios
    .delete(model.baseUrl + 'FileFolders', {
      data: {
        FolderCode: FolderCode,
        WithSubfolder: WithSubfolder
      }
    })
    .then(extract);
}

async function OrgAdd(folderName, parentFolderCode, deparmens, isEmployee) {
  return axios
    .put(model.baseUrl + 'FileFolders/org', {
      FolderName: folderName,
      ParentFolderCode: parentFolderCode,
      Deparmens: deparmens,
      IsEmployee: isEmployee
    })
    .then(extract);
}

async function OrgEdit(FolderCode, FolderName, deparmens) {
  return axios
    .patch(model.baseUrl + 'FileFolders/org', {
      FolderCode: FolderCode,
      FolderName: FolderName,
      Deparmens: deparmens
    })
    .then(extract);
}

async function OrgParentEdit(FolderCode, ParentFolderCode) {
  return axios
    .patch(model.baseUrl + 'FileFolders/orgParentEdit', {
      FolderCode: FolderCode,
      ParentFolderCode: ParentFolderCode
    })
    .then(extract);
}

async function OrgFolderDocChange(DocumentVersionCodes, FolderCode) {
  return axios
    .patch(model.baseUrl + 'FileFolders/orgFoldersDocChange', {
      DocumentVersionCodes: DocumentVersionCodes,
      FolderCode: FolderCode
    })
    .then(extract);
}

async function OrgDel(FolderCode, WithSubfolder) {
  return axios
    .delete(model.baseUrl + 'FileFolders/Org', {
      data: {
        FolderCode: FolderCode,
        WithSubfolder: WithSubfolder
      }
    })
    .then(extract);
}
